import { render } from "./Modal.vue?vue&type=template&id=5f7088f2"
import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f7088f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f7088f2', __exports__)) {
    api.reload('5f7088f2', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=5f7088f2", () => {
    api.rerender('5f7088f2', render)
  })

}


export default __exports__